import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewalltemplateComponent } from './components/viewalltemplate/viewalltemplate.component';
import { HomeComponent } from './components/home/home.component';
import { TemplatePreviewComponent } from './components/template-preview/template-preview.component';
import { CartComponent } from './components/cart/cart.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'viewalltemplate', component: ViewalltemplateComponent },
  { path: 'template-preview', component: TemplatePreviewComponent },
  { path: 'template-preview/:id', component: TemplatePreviewComponent },
  { path: 'cart', component: CartComponent },
  { path: 'viewalltemplate/packages/:id', component: ViewalltemplateComponent },
  { path: 'viewalltemplate/all_templates', component: ViewalltemplateComponent },
  { path: 'thank-you', component: ThankYouComponent },
  { path: 'thank-you/:session_key', component: ThankYouComponent },
  { path: '**', redirectTo: '/home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

